

























import Vue from 'vue'
import { getReport } from '@/api/Topup/topup.api'
import { Report } from '@/utils/interfaces/topup.interface'
import { formatNumber } from '@/utils/functions'
export default Vue.extend({
  data: function() {
    return {
      reports: {} as Report,
    }
  },
  computed: {
    myData(): object {
      if (!Object.keys(this.reports).length) return {}
      let today = ''
      let week = ''

      const cupToday =
        this.reports.CUP.earnings[this.reports.CUP.earnings.length - 1] | 0
      const usdToday = this.reports.USD.earnings[
        this.reports.USD.earnings.length - 1
      ]

      const cupWeek = this.reports.totals.CUP.earnings
      const usdWeek = this.reports.totals.USD.earnings

      today += formatNumber(cupToday) + ' CUP'
      today += ' | '
      today += formatNumber(usdToday) + ' USD'

      week += formatNumber(cupWeek) + ' CUP'
      week += ' | '
      week += formatNumber(usdWeek) + ' USD'

      return {
        today: today,
        week: week,
        'topup.total': this.reports.totals.topups,
      }
    },
  },
  async mounted() {
    const response = await getReport()
    this.reports = response.data
  },
})
